import { apiClient } from "./config";

/**
 * Clone copier
 * @param data
 * @returns {Promise<any>}
 */
export const cloneCopier = async (data) => {
	const { config, params } = data;
	const { copierId, organizationId, ...body } = params;
	const response = await apiClient({
		method: "COPY",
		url: `/admin/organizations/${organizationId}/copiers/${copierId}`,
		data: body,
		...config,
	});
	return response.data;
};
